// import React, { useEffect, useState } from "react";
// import api from "../../services/api";

// export default function RegionDistrictEgliseAspirants() {
//   const [districts, setDistricts] = useState([]);
//   const [eglises, setEglises] = useState([]);
//   const [aspirants, setAspirants] = useState([]);

//   const [selectedDistrict, setSelectedDistrict] = useState(null);
//   const [selectedEglise, setSelectedEglise] = useState(null);

//   const [progressCGByAspirant, setProgressCGByAspirant] = useState({});
//   const [progressSYLByAspirant, setProgressSYLByAspirant] = useState({});

//   const [loading, setLoading] = useState({ d: false, e: false, a: false, p: false });
//   const [err, setErr] = useState("");

//   useEffect(() => {
//     const load = async () => {
//       try {
//         setLoading(s => ({ ...s, d: true }));
//         const res = await api.get("/regionStats/districts");
//         setDistricts(res.data || []);
//         setErr("");
//       } catch (e) {
//         console.error("Erreur districts:", e?.response || e);
//         setErr(e?.response?.status === 403 ? "Accès refusé (coordinateur_region/admin requis)" : "Erreur de chargement");
//       } finally {
//         setLoading(s => ({ ...s, d: false }));
//       }
//     };
//     load();
//   }, []);

//   const onSelectDistrict = async (districtId) => {
//     setSelectedDistrict(districtId);
//     setSelectedEglise(null);
//     setEglises([]);
//     setAspirants([]);
//     setProgressCGByAspirant({});
//     setProgressSYLByAspirant({});
//     try {
//       setLoading(s => ({ ...s, e: true }));
//       const res = await api.get(`/regionStats/district/${districtId}/eglises`);
//       setEglises(res.data || []);
//     } catch (e) {
//       console.error("Erreur églises:", e);
//     } finally {
//       setLoading(s => ({ ...s, e: false }));
//     }
//   };

//   const onSelectEglise = async (egliseId) => {
//     setSelectedEglise(egliseId);
//     setAspirants([]);
//     setProgressCGByAspirant({});
//     setProgressSYLByAspirant({});
//     try {
//       setLoading(s => ({ ...s, a: true }));
//       const res = await api.get(`/regionStats/eglise/${egliseId}/aspirants`);
//       setAspirants(res.data || []);
//     } catch (e) {
//       console.error("Erreur aspirants:", e);
//     } finally {
//       setLoading(s => ({ ...s, a: false }));
//     }

//     try {
//       setLoading(s => ({ ...s, p: true }));
//       const [cg, syl] = await Promise.all([
//         api.get(`/regionStats/eglise/${egliseId}/progress/CG`).then(r => r.data),
//         api.get(`/regionStats/eglise/${egliseId}/progress/SYL`).then(r => r.data),
//       ]);
//       const mapCG = {}; (cg || []).forEach(r => { mapCG[r.aspirant_id] = r; });
//       const mapSYL = {}; (syl || []).forEach(r => { mapSYL[r.aspirant_id] = r; });
//       setProgressCGByAspirant(mapCG);
//       setProgressSYLByAspirant(mapSYL);
//     } catch (e) {
//       console.error("Erreur progress:", e);
//     } finally {
//       setLoading(s => ({ ...s, p: false }));
//     }
//   };

//   const isCG  = (p) => p === "Chef Guide" || p === "CG";
//   const isSYL = (p) => p === "Senior Youth Leader" || p === "SYL";

//   return (
//     <div className="row g-3">
//       <div className="col-lg-4">
//         <div className="card shadow-sm">
//           <div className="card-header bg-primary text-white">Districts (région)</div>
//           <ul className="list-group list-group-flush">
//             {loading.d ? (
//               <li className="list-group-item text-muted">Chargement…</li>
//             ) : err ? (
//               <li className="list-group-item text-danger">{err}</li>
//             ) : districts.length === 0 ? (
//               <li className="list-group-item text-muted">Aucun district</li>
//             ) : (
//               districts.map(d => (
//                 <li
//                   key={d.district_id}
//                   className={`list-group-item d-flex justify-content-between align-items-center ${selectedDistrict === d.district_id ? "active text-white" : ""}`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => onSelectDistrict(d.district_id)}
//                 >
//                   <span>{d.district_name}</span>
//                   <span>
//                     <span className="badge bg-success me-2">CG: {d.total_CG}</span>
//                     <span className="badge bg-danger">SYL: {d.total_SYL}</span>
//                   </span>
//                 </li>
//               ))
//             )}
//           </ul>
//         </div>
//       </div>

//       {/* Col 2: Églises */}
//       <div className="col-lg-4">
//         <div className="card shadow-sm">
//           <div className="card-header bg-primary text-white">Églises du district</div>
//           <ul className="list-group list-group-flush">
//             {selectedDistrict == null ? (
//               <li className="list-group-item text-muted">Sélectionne un district</li>
//             ) : loading.e ? (
//               <li className="list-group-item text-muted">Chargement…</li>
//             ) : eglises.length === 0 ? (
//               <li className="list-group-item text-muted">Aucune église</li>
//             ) : (
//               eglises.map(e => (
//                 <li
//                   key={e.eglise_id}
//                   className={`list-group-item d-flex justify-content-between align-items-center ${selectedEglise === e.eglise_id ? "active text-white" : ""}`}
//                   style={{ cursor: "pointer" }}
//                   onClick={() => onSelectEglise(e.eglise_id)}
//                 >
//                   <span>{e.eglise_name}</span>
//                   <span>
//                     <span className="badge bg-success me-2">CG: {e.total_CG}</span>
//                     <span className="badge bg-danger">SYL: {e.total_SYL}</span>
//                   </span>
//                 </li>
//               ))
//             )}
//           </ul>
//         </div>
//       </div>

//       <div className="col-lg-4">
//         <div className="card shadow-sm">
//           <div className="card-header bg-primary text-white">Aspirants de l'église</div>
//           <div className="card-body p-0">
//             {selectedEglise == null ? (
//               <div className="p-3 text-muted">Sélectionne une église</div>
//             ) : loading.a ? (
//               <div className="p-3 text-muted">Chargement des aspirants…</div>
//             ) : aspirants.length === 0 ? (
//               <div className="p-3 text-muted">Aucun élève</div>
//             ) : (
//               <div className="table-responsive">
//                 <table className="table table-bordered table-sm mb-0">
//                   <thead className="table-light">
//                     <tr>
//                       <th>Nom</th>
//                       <th>Parcours</th>
//                       <th>Progress</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {aspirants.map(a => {
//                       const progCG  = progressCGByAspirant[a.id]?.progress ?? null;
//                       const progSYL = progressSYLByAspirant[a.id]?.progress ?? null;
//                       const showCG  = isCG(a.parcours) && progCG !== null;
//                       const showSYL = isSYL(a.parcours) && progSYL !== null;
//                       const pct = showCG ? progCG : showSYL ? progSYL : null;

//                       return (
//                         <tr key={a.id}>
//                           <td>{a.aspirant_name}</td>
//                           <td>{a.parcours}</td>
//                           <td>
//                             {loading.p ? (
//                               <span className="text-muted">Calcul…</span>
//                             ) : pct !== null ? (
//                               <div className="progress" style={{ height: 18 }}>
//                                 <div
//                                   className={`progress-bar ${pct === 100 ? "bg-success" : showCG ? "bg-info" : "bg-warning"}`}
//                                   role="progressbar"
//                                   style={{ width: `${pct}%` }}
//                                   aria-valuenow={pct}
//                                   aria-valuemin="0"
//                                   aria-valuemax="100"
//                                 >
//                                   {pct}%
//                                 </div>
//                               </div>
//                             ) : (
//                               <span className="text-muted">—</span>
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { formatParcours } from "../../services/aspirantUtils";

export default function RegionDistrictEgliseAspirants() {
  const [districts, setDistricts] = useState([]);
  const [eglises, setEglises] = useState([]);
  const [aspirants, setAspirants] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedEglise, setSelectedEglise] = useState(null);

  const [progressCGByAspirant, setProgressCGByAspirant] = useState({});
  const [progressSYLByAspirant, setProgressSYLByAspirant] = useState({});

  const [loading, setLoading] = useState({ d: false, e: false, a: false, p: false });
  const [err, setErr] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(s => ({ ...s, d: true }));
        const res = await api.get("/regionStats/districts");
        setDistricts(res.data || []);
        setErr("");
      } catch (e) {
        console.error("Erreur districts:", e?.response || e);
        setErr(e?.response?.status === 403 ? "Accès refusé (coordinateur_region/admin requis)" : "Erreur de chargement");
      } finally {
        setLoading(s => ({ ...s, d: false }));
      }
    };
    load();
    
    // Charger la progression pour toute la région au chargement initial
    // Cela permet d'avoir la progression disponible même sans sélectionner d'église
    const loadInitialProgress = async () => {
      try {
        setLoading(s => ({ ...s, p: true }));
        const [cgRes, sylRes] = await Promise.all([
          api.get(`/regionStats/region/progress/CG`).catch(err => {
            console.error(`❌ Erreur CG pour région:`, err?.response?.status, err?.response?.data);
            return { data: [] };
          }),
          api.get(`/regionStats/region/progress/SYL`).catch(err => {
            console.error(`❌ Erreur SYL pour région:`, err?.response?.status, err?.response?.data);
            return { data: [] };
          })
        ]);

        const cgData = cgRes?.data || [];
        const sylData = sylRes?.data || [];
        
        const combinedCG = {};
        const combinedSYL = {};
        
        cgData.forEach(r => {
          const id = String(r.aspirant_id ?? r.id ?? r.user_id ?? "");
          if (id && id !== "undefined" && id !== "null" && id !== "") {
            const done = Number(r.done ?? 0) || 0;
            const total = Number(r.total ?? 0) || 0;
            let percent = r.progress != null ? Number(r.progress) : null;
            if (percent === null || !Number.isFinite(percent)) {
              percent = total > 0 ? Math.round((done / total) * 100) : 0;
            }
            combinedCG[id] = { 
              done, 
              total, 
              progress: Math.max(0, Math.min(100, Math.round(percent))) 
            };
          }
        });
        
        sylData.forEach(r => {
          const id = String(r.aspirant_id ?? r.id ?? r.user_id ?? "");
          if (id && id !== "undefined" && id !== "null" && id !== "") {
            const done = Number(r.done ?? 0) || 0;
            const total = Number(r.total ?? 0) || 0;
            let percent = r.progress != null ? Number(r.progress) : null;
            if (percent === null || !Number.isFinite(percent)) {
              percent = total > 0 ? Math.round((done / total) * 100) : 0;
            }
            combinedSYL[id] = { 
              done, 
              total, 
              progress: Math.max(0, Math.min(100, Math.round(percent))) 
            };
          }
        });
        
        setProgressCGByAspirant(combinedCG);
        setProgressSYLByAspirant(combinedSYL);
      } catch (err) {
        console.error("Erreur chargement progression initiale:", err);
      } finally {
        setLoading(s => ({ ...s, p: false }));
      }
    };
    
    loadInitialProgress();
  }, []);

  const onSelectDistrict = async (districtId) => {
    setSelectedDistrict(districtId);
    setSelectedEglise(null);
    setEglises([]);
    setAspirants([]);
    setProgressCGByAspirant({});
    setProgressSYLByAspirant({});
    try {
      setLoading(s => ({ ...s, e: true }));
      const res = await api.get(`/regionStats/district/${districtId}/eglises`);
      setEglises(res.data || []);
    } catch (e) {
      console.error("Erreur églises:", e);
    } finally {
      setLoading(s => ({ ...s, e: false }));
    }
  };

  // Fonction pour charger la progression pour tous les aspirants de la région
  const loadProgressForAspirants = async (aspirantsList) => {
    if (!aspirantsList || aspirantsList.length === 0) return;

    try {
      setLoading(s => ({ ...s, p: true }));
      
      // Utiliser la nouvelle route qui charge directement pour toute la région
      const [cgRes, sylRes] = await Promise.all([
        api.get(`/regionStats/region/progress/CG`).catch(err => {
          console.error(`❌ Erreur CG pour région:`, err?.response?.status, err?.response?.data);
          return { data: [] };
        }),
        api.get(`/regionStats/region/progress/SYL`).catch(err => {
          console.error(`❌ Erreur SYL pour région:`, err?.response?.status, err?.response?.data);
          return { data: [] };
        })
      ]);

      const cgData = cgRes?.data || [];
      const sylData = sylRes?.data || [];
      
      // Combiner toutes les progressions
      const combinedCG = {};
      const combinedSYL = {};
      
      cgData.forEach(r => {
        const id = String(r.aspirant_id ?? r.id ?? r.user_id ?? "");
        if (id && id !== "undefined" && id !== "null" && id !== "") {
          const done = Number(r.done ?? 0) || 0;
          const total = Number(r.total ?? 0) || 0;
          let percent = r.progress != null ? Number(r.progress) : null;
          if (percent === null || !Number.isFinite(percent)) {
            percent = total > 0 ? Math.round((done / total) * 100) : 0;
          }
          combinedCG[id] = { 
            done, 
            total, 
            progress: Math.max(0, Math.min(100, Math.round(percent))) 
          };
        }
      });
      
      sylData.forEach(r => {
        const id = String(r.aspirant_id ?? r.id ?? r.user_id ?? "");
        if (id && id !== "undefined" && id !== "null" && id !== "") {
          const done = Number(r.done ?? 0) || 0;
          const total = Number(r.total ?? 0) || 0;
          let percent = r.progress != null ? Number(r.progress) : null;
          if (percent === null || !Number.isFinite(percent)) {
            percent = total > 0 ? Math.round((done / total) * 100) : 0;
          }
          combinedSYL[id] = { 
            done, 
            total, 
            progress: Math.max(0, Math.min(100, Math.round(percent))) 
          };
        }
      });
      
      // Fusionner avec les progressions existantes
      setProgressCGByAspirant(prev => ({ ...prev, ...combinedCG }));
      setProgressSYLByAspirant(prev => ({ ...prev, ...combinedSYL }));
    } catch (err) {
      console.error("Erreur chargement progression:", err);
    } finally {
      setLoading(s => ({ ...s, p: false }));
    }
  };

  const onSelectEglise = async (egliseId) => {
    setSelectedEglise(egliseId);
    setAspirants([]);
    setProgressCGByAspirant({});
    setProgressSYLByAspirant({});
    
    // Charger les aspirants d'abord
    let aspirantsData = [];
    try {
      setLoading(s => ({ ...s, a: true }));
      const res = await api.get(`/regionStats/eglise/${egliseId}/aspirants`);
      aspirantsData = res.data || [];
      // Ajouter eglise_id à chaque aspirant si absent
      aspirantsData = aspirantsData.map(a => ({
        ...a,
        eglise_id: a.eglise_id || egliseId
      }));
      setAspirants(aspirantsData);
      // Charger la progression après avoir chargé les aspirants
      if (aspirantsData.length > 0) {
        await loadProgressForAspirants(aspirantsData);
      }
    } catch (e) {
      console.error("Erreur aspirants:", e);
      setAspirants([]);
    } finally {
      setLoading(s => ({ ...s, a: false }));
    }
  };

  const isCG  = (p) => p === "Chef Guide" || p === "CG";
  const isSYL = (p) => p === "Senior Youth Leader" || p === "SYL";

  return (
    <div className="card shadow-sm mt-4">
      <div className="card-header bg-primary text-white">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <strong>Liste des élèves de la Région</strong>
            <div className="small text-white-50">
              {!selectedDistrict
                ? "Liste des districts"
                : !selectedEglise
                ? "Liste des églises"
                : "👥 Aspirants"}
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        {err && <div className="alert alert-danger">{err}</div>}

        {/* --- DISTRICTS --- */}
        {!selectedDistrict && (
          <div className="row g-3">
            {loading.d ? (
              <div className="text-muted">Chargement…</div>
            ) : districts.length === 0 ? (
              <div className="text-muted">Aucun district</div>
            ) : (
              districts.map(d => (
                <div key={d.district_id} className="col-md-4">
                  <div
                    className={`p-3 border rounded shadow-sm bg-white d-flex justify-content-between align-items-center ${selectedDistrict === d.district_id ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectDistrict(d.district_id)}
                  >
                    <div>
                      <div className="fw-semibold">{d.district_name}</div>
                      <div className="small text-muted">
                        <span className="badge bg-primary me-2 px-3 py-2">CG: {d.total_CG}</span>
                        <span className="badge text-white px-3 py-2" style={{ backgroundColor: "#6e0b14" }}>SYL: {d.total_SYL}</span>
                      </div>
                    </div>
                    <i className="bi bi-chevron-right"></i>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* --- EGLISES --- */}
        {selectedDistrict && !selectedEglise && (
          <div className="row g-3">
            {loading.e ? (
              <div className="text-muted">Chargement…</div>
            ) : eglises.length === 0 ? (
              <div className="text-muted">Aucune église</div>
            ) : (
              eglises.map(e => (
                <div key={e.eglise_id} className="col-md-4">
                  <div
                    className={`p-3 border rounded shadow-sm bg-white d-flex justify-content-between align-items-center ${selectedEglise === e.eglise_id ? "active" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectEglise(e.eglise_id)}
                  >
                    <div>
                      <div className="fw-semibold">{e.eglise_name}</div>
                      <div className="small text-muted">
                        <span className="badge bg-primary me-2 px-3 py-2">CG: {e.total_CG}</span>
                        <span className="badge text-white px-3 py-2" style={{ backgroundColor: "#6e0b14" }}>SYL: {e.total_SYL}</span>
                      </div>
                    </div>
                    <i className="bi bi-chevron-right"></i>
                  </div>
                </div>
              ))
            )}
          </div>
        )}

        {/* --- ASPIRANTS --- */}
        {selectedEglise && (
          <>
            {/* Version desktop : tableau */}
            <div className="table-responsive d-none d-md-block">
              <table className="table table-hover table-sm align-middle">
                <thead className="table-light">
                  <tr>
                    <th>Nom</th>
                    <th>Matricule</th>
                    <th>Parcours</th>
                    <th>Progression</th>
                  </tr>
                </thead>
                <tbody>
                  {loading.a ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        Chargement…
                      </td>
                    </tr>
                  ) : aspirants.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        Aucun élève
                      </td>
                    </tr>
                  ) : (
                    aspirants.map(a => {
                      // Convertir l'ID en string pour correspondre aux clés des maps
                      // Le backend retourne aspirant_id directement
                      const aspirantId = String(a.aspirant_id ?? a.id ?? a.user_id ?? "");
                      const progDataCG = progressCGByAspirant[aspirantId];
                      const progDataSYL = progressSYLByAspirant[aspirantId];
                      
                      // Extraire progress directement, avec fallback sur done/total
                      let progCG = progDataCG?.progress;
                      let progSYL = progDataSYL?.progress;
                      if (progCG === null || progCG === undefined) {
                        const done = Number(progDataCG?.done) || 0;
                        const total = Number(progDataCG?.total) || 0;
                        progCG = total > 0 ? Math.round((done / total) * 100) : null;
                      }
                      if (progSYL === null || progSYL === undefined) {
                        const done = Number(progDataSYL?.done) || 0;
                        const total = Number(progDataSYL?.total) || 0;
                        progSYL = total > 0 ? Math.round((done / total) * 100) : null;
                      }
                      const showCG  = isCG(a.parcours) && progCG !== null && progCG !== undefined && Number.isFinite(progCG);
                      const showSYL = isSYL(a.parcours) && progSYL !== null && progSYL !== undefined && Number.isFinite(progSYL);
                      const pct = showCG ? Math.max(0, Math.min(100, Math.round(progCG))) : showSYL ? Math.max(0, Math.min(100, Math.round(progSYL))) : null;

                      const barClass =
                        showCG ? "bg-info"
                        : showSYL ? "bg-success"
                        : "bg-secondary";

                      return (
                        <tr key={aspirantId}>
                          <td>{a.aspirant_name}</td>
                          <td>
                            {a.matricule ? (
                              <span className="badge bg-success text-white">{a.matricule}</span>
                            ) : (
                              <span className="badge bg-warning text-dark">En attente</span>
                            )}
                          </td>
                          <td>{formatParcours(a.parcours)}</td>
                          <td style={{ minWidth: 240 }}>
                            {loading.p ? (
                              <span className="text-muted">Calcul…</span>
                            ) : pct !== null ? (
                              <div className="progress" style={{ height: 18 }}>
                                <div
                                  className={`progress-bar ${barClass}`}
                                  role="progressbar"
                                  style={{ width: `${pct}%` }}
                                  aria-valuenow={pct}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                >
                                  {pct}%
                                </div>
                              </div>
                            ) : (
                              <span className="text-muted">—</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Version mobile : cartes */}
            <div className="d-md-none">
              {loading.a ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement…</span>
                  </div>
                </div>
              ) : aspirants.length === 0 ? (
                <div className="text-center py-4 text-muted">
                  Aucun élève
                </div>
              ) : (
                aspirants.map(a => {
                  // Le backend retourne aspirant_id directement
                  const aspirantId = String(a.aspirant_id ?? a.id ?? a.user_id ?? "");
                  const progDataCG = progressCGByAspirant[aspirantId];
                  const progDataSYL = progressSYLByAspirant[aspirantId];
                  
                  // Extraire progress directement, avec fallback sur done/total
                  let progCG = progDataCG?.progress;
                  let progSYL = progDataSYL?.progress;
                  if (progCG === null || progCG === undefined) {
                    const done = Number(progDataCG?.done) || 0;
                    const total = Number(progDataCG?.total) || 0;
                    progCG = total > 0 ? Math.round((done / total) * 100) : null;
                  }
                  if (progSYL === null || progSYL === undefined) {
                    const done = Number(progDataSYL?.done) || 0;
                    const total = Number(progDataSYL?.total) || 0;
                    progSYL = total > 0 ? Math.round((done / total) * 100) : null;
                  }
                  const showCG  = isCG(a.parcours) && progCG !== null && progCG !== undefined && Number.isFinite(progCG);
                  const showSYL = isSYL(a.parcours) && progSYL !== null && progSYL !== undefined && Number.isFinite(progSYL);
                  const pct = showCG ? Math.max(0, Math.min(100, Math.round(progCG))) : showSYL ? Math.max(0, Math.min(100, Math.round(progSYL))) : null;

                  const barClass =
                    showCG ? "bg-info"
                    : showSYL ? "bg-success"
                    : "bg-secondary";

                  return (
                    <div key={aspirantId} className="card mb-3 shadow-sm">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="flex-grow-1">
                            <h6 className="fw-semibold mb-1">{a.aspirant_name}</h6>
                            <div className="mb-2">
                              <small className="text-muted d-block">Matricule:</small>
                              {a.matricule ? (
                                <span className="badge bg-success text-white">{a.matricule}</span>
                              ) : (
                                <span className="badge bg-warning text-dark">En attente</span>
                              )}
                            </div>
                          </div>
                          <div>
                            <span className="badge bg-info text-dark">{formatParcours(a.parcours)}</span>
                          </div>
                        </div>
                        
                        <div className="mb-2">
                          <small className="text-muted d-block mb-1">Progression:</small>
                          {loading.p ? (
                            <span className="text-muted">Calcul…</span>
                          ) : pct !== null ? (
                            <>
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <small className="text-muted">{pct}%</small>
                              </div>
                              <div className="progress" style={{ height: 18 }}>
                                <div
                                  className={`progress-bar ${barClass}`}
                                  role="progressbar"
                                  style={{ width: `${pct}%` }}
                                  aria-valuenow={pct}
                                  aria-valuemin="0"
                                  aria-valuemax="100"
                                />
                              </div>
                            </>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            <div className="d-flex gap-2 mt-2">
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setSelectedEglise(null)}
              >
                ← Églises
              </button>
              <button
                className="btn btn-outline-secondary btn-sm"
                onClick={() => setSelectedDistrict(null)}
              >
                ← Districts
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
